// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thumbnail {
  text-align: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-bottom: 1rem;
  cursor: pointer;
}

.folder-section .thumbnail {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-bottom: 1rem;
  text-align: left;
}

.thumbnail:hover {
  font-weight: 600;
}

.blog-card:hover .media-delete {
  opacity: 1;
  z-index: 4; 
}

.folder-section .thumbnail .thumbnail-icon {
  margin-top: 5px;
  color: #fff;
  position: relative;
  display: inline-block;
  width: 70%;
  height: 35px;
}

.thumbnail .media-delete { 
  position: absolute;
  opacity: 0;
  transition: all ease-in-out 0.2s;
  background: white;
  border-radius: 0 0px 0px 20px;
  box-shadow: -2px 2px 2px 0px #0000003b;
  z-index: 999;
  top: 0px;
  right: 15px;
}

.thumbnail .thumbnail-image {
  flex-grow: 1;
  max-width: 100%;
  object-fit: cover;
  border: 2px solid #fff;
  border-bottom: none;
  background: #fff;
  padding: 0.25rem;
}

.thumbnail .thumbnail-text {
  margin: 0;
  padding: 0.25rem 1rem;
  text-align: center;
  overflow: hidden;
  color: #fff;
  height: 3em;
}

.files-section .thumbnail .thumbnail-text {
  color: black;
  padding-top:10px
}

.folder-section {
  background: #343a40;
  width: 100%;
  position: absolute;
  bottom: 0;
  top: 55px;
  right: 0;
  border-top: 1px solid #898989;
}

.menu-text {
  color: #fff;
}

.add-new-comp {
  background: #7e55b3;
  border: 0px !important;
  padding: 0.5em !important;
  width: 100%;
  color: #fff;
  border-radius: 5px;
  margin-bottom: 8px;
}

.folder-icon {
  font-size: 24px;
}

.folder-delete {
  display: inline-block;
  float: right;
  /* padding: 10px 20px; */
}
.folder-delete > i {
  color: white;
}

.dorp-zone-media {
  border: 1px dashed rgb(0, 161, 255);
  border-radius: 5px;
  padding: 17px 0em 1em 27px;
}

.active-cat {
  background: #564675;
}

.button-container {
  background-color: transparent;
  outline: none;
  border: none;
  padding: 5px;
}


.blog-card{
  background: white;
    border: 1px solid white;
    /* margin-right: 15px; */
    border-radius: 5px;
   
    padding: 0;
    height: 200px;
}

.blog-card:hover{
 box-shadow: 2px 1px 2px 0px #cecece;
}

.thumbnail .thumbnail-image{
  height: 150px;
  padding:0;
  margin:0;
  width: 100%;
  border:0px
}

.thumbnail {
width: 100%;
padding:0

}

.thumbnail .thumbnail-image:hover{
  box-shadow: 0px 0px 0px 0px #fff;
}
::ng-deep .menu-content .mat-menu-content:not(:empty) {
   padding-top: 0 !important; 
  padding-bottom: 0 !important; 
}
 
 .bg-gray{
  background: #f2f2f2;
    border-top: solid 2px #fff;
 }
 .cut-word {
  max-width: 250px;
  /* white-space: nowrap;  */
  overflow: hidden;
  text-overflow: ellipsis;
}
 
.table tr td.actions.one, .table tr th.actions.one {
  width: 3.5rem;
}
.actions a.danger {
  color: #a94441;
}
.actions a {
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  text-align: center;
  line-height: 1.5rem;
  border-radius: 50%;
  transition: background-color ease-in-out .15s,color ease-in-out .15s;
}
.actions a.danger:focus, .actions a.danger:hover {
  background-color: #a94441;
  color: #fff;
}

.table tbody tr.unpublished {
  opacity: .6;
}`, "",{"version":3,"sources":["webpack://./src/app/views/blogs-articles/blogs-articles.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,iBAAiB;EACjB,6BAA6B;EAC7B,sCAAsC;EACtC,YAAY;EACZ,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;;AAGA;EACE,iBAAiB;IACf,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;;IAElB,UAAU;IACV,aAAa;AACjB;;AAEA;CACC,mCAAmC;AACpC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,QAAQ;EACR,WAAW;EACX;AACF;;AAEA;AACA,WAAW;AACX;;AAEA;;AAEA;EACE,gCAAgC;AAClC;AACA;GACG,yBAAyB;EAC1B,4BAA4B;AAC9B;;CAEC;EACC,mBAAmB;IACjB,0BAA0B;CAC7B;CACA;EACC,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oEAAoE;AACtE;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":[".thumbnail {\r\n  text-align: center;\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n  margin-bottom: 1rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.folder-section .thumbnail {\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n  margin-bottom: 1rem;\r\n  text-align: left;\r\n}\r\n\r\n.thumbnail:hover {\r\n  font-weight: 600;\r\n}\r\n\r\n.blog-card:hover .media-delete {\r\n  opacity: 1;\r\n  z-index: 4; \r\n}\r\n\r\n.folder-section .thumbnail .thumbnail-icon {\r\n  margin-top: 5px;\r\n  color: #fff;\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 70%;\r\n  height: 35px;\r\n}\r\n\r\n.thumbnail .media-delete { \r\n  position: absolute;\r\n  opacity: 0;\r\n  transition: all ease-in-out 0.2s;\r\n  background: white;\r\n  border-radius: 0 0px 0px 20px;\r\n  box-shadow: -2px 2px 2px 0px #0000003b;\r\n  z-index: 999;\r\n  top: 0px;\r\n  right: 15px;\r\n}\r\n\r\n.thumbnail .thumbnail-image {\r\n  flex-grow: 1;\r\n  max-width: 100%;\r\n  object-fit: cover;\r\n  border: 2px solid #fff;\r\n  border-bottom: none;\r\n  background: #fff;\r\n  padding: 0.25rem;\r\n}\r\n\r\n.thumbnail .thumbnail-text {\r\n  margin: 0;\r\n  padding: 0.25rem 1rem;\r\n  text-align: center;\r\n  overflow: hidden;\r\n  color: #fff;\r\n  height: 3em;\r\n}\r\n\r\n.files-section .thumbnail .thumbnail-text {\r\n  color: black;\r\n  padding-top:10px\r\n}\r\n\r\n.folder-section {\r\n  background: #343a40;\r\n  width: 100%;\r\n  position: absolute;\r\n  bottom: 0;\r\n  top: 55px;\r\n  right: 0;\r\n  border-top: 1px solid #898989;\r\n}\r\n\r\n.menu-text {\r\n  color: #fff;\r\n}\r\n\r\n.add-new-comp {\r\n  background: #7e55b3;\r\n  border: 0px !important;\r\n  padding: 0.5em !important;\r\n  width: 100%;\r\n  color: #fff;\r\n  border-radius: 5px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.folder-icon {\r\n  font-size: 24px;\r\n}\r\n\r\n.folder-delete {\r\n  display: inline-block;\r\n  float: right;\r\n  /* padding: 10px 20px; */\r\n}\r\n.folder-delete > i {\r\n  color: white;\r\n}\r\n\r\n.dorp-zone-media {\r\n  border: 1px dashed rgb(0, 161, 255);\r\n  border-radius: 5px;\r\n  padding: 17px 0em 1em 27px;\r\n}\r\n\r\n.active-cat {\r\n  background: #564675;\r\n}\r\n\r\n.button-container {\r\n  background-color: transparent;\r\n  outline: none;\r\n  border: none;\r\n  padding: 5px;\r\n}\r\n\r\n\r\n.blog-card{\r\n  background: white;\r\n    border: 1px solid white;\r\n    /* margin-right: 15px; */\r\n    border-radius: 5px;\r\n   \r\n    padding: 0;\r\n    height: 200px;\r\n}\r\n\r\n.blog-card:hover{\r\n box-shadow: 2px 1px 2px 0px #cecece;\r\n}\r\n\r\n.thumbnail .thumbnail-image{\r\n  height: 150px;\r\n  padding:0;\r\n  margin:0;\r\n  width: 100%;\r\n  border:0px\r\n}\r\n\r\n.thumbnail {\r\nwidth: 100%;\r\npadding:0\r\n\r\n}\r\n\r\n.thumbnail .thumbnail-image:hover{\r\n  box-shadow: 0px 0px 0px 0px #fff;\r\n}\r\n::ng-deep .menu-content .mat-menu-content:not(:empty) {\r\n   padding-top: 0 !important; \r\n  padding-bottom: 0 !important; \r\n}\r\n \r\n .bg-gray{\r\n  background: #f2f2f2;\r\n    border-top: solid 2px #fff;\r\n }\r\n .cut-word {\r\n  max-width: 250px;\r\n  /* white-space: nowrap;  */\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n \r\n.table tr td.actions.one, .table tr th.actions.one {\r\n  width: 3.5rem;\r\n}\r\n.actions a.danger {\r\n  color: #a94441;\r\n}\r\n.actions a {\r\n  display: inline-block;\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n  text-align: center;\r\n  line-height: 1.5rem;\r\n  border-radius: 50%;\r\n  transition: background-color ease-in-out .15s,color ease-in-out .15s;\r\n}\r\n.actions a.danger:focus, .actions a.danger:hover {\r\n  background-color: #a94441;\r\n  color: #fff;\r\n}\r\n\r\n.table tbody tr.unpublished {\r\n  opacity: .6;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
